import Rollbar from 'rollbar-browser';
import SessionManager from 'helpers/SessionManager';
import Routes from 'helpers/Routes';
import 'babel-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import LoginDropdown from 'components/application/LoginDropdown';

window.SessionManager = new SessionManager();
window.Routes = Routes;
window.Rollbar = Rollbar;

document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('.login-dropdown');
  Array.prototype.forEach.call(elements, (el, i) => { // hack for old browsers
    ReactDOM.render(React.createElement(LoginDropdown), el);
  });
});




// WEBPACK FOOTER //
// ./app/javascript/packs/application.js